import { getOrganicProductCount } from "../../common/CriteoAdvertsForRecs";
import { APP, PLACEMENT } from "@asosteam/asos-web-adverts-sdk";
import { logError, ERROR_TYPE } from "../utils/newRelicLogger";

const criteoApi = async (criteoRequiredParams) => {
  const {
    productIdCollection,
    productId,
    isInStock,
    price,
    advertsSdkInstance,
    ABTestConfig,
  } = criteoRequiredParams;

  const PAGE_NUMBER = 1;

  if (!productIdCollection?.length || !advertsSdkInstance?.getAdverts)
    return {};

  const {
    current: { value },
  } = price;

  const listSize = getOrganicProductCount(productIdCollection, ABTestConfig);
  const productIdCollectionPiped = productIdCollection.join("|");

  const parameters = {
    "page-number": PAGE_NUMBER,
    "list-size": listSize,
    "parent-item": productId,
    "item-whitelist": productIdCollectionPiped,
    "list-price": value || 0,
    filters: "",
    availability: Number(isInStock),
    price: value || 0,
  };

  const options = {
    app: APP.PDP,
    placement: PLACEMENT.SPONSORED_PRODUCTS,
    requestDisplayAdverts: true,
    requestSponsoredProducts: true,
    breakCache: true,
  };

  try {
    return await advertsSdkInstance.getAdverts({
      options,
      parameters,
    });
  } catch (error) {
    logError(ERROR_TYPE.NonCriticalAppError, {
      message: error.message,
      action: "CriteoAdvertCall",
    });
    return {};
  }
};

export default criteoApi;
